import React, { useEffect, useState, useRef } from "react";
import "./FormFieldsStyle.css";
import apiService from "../Services/apiServices"; // Adjust import path

const InputField = (props) => {
  const [inputVal, setInputVal] = useState(props?.item?.text || "");
  const [isSpecialError, setIsSpecialError] = useState("");
  const [isLimitError, setIsLimitlError] = useState("");
  const [suggestions, setSuggestions] = useState([]); 
  const [loading, setLoading] = useState(false);
  const debounceTimeout = useRef(null);
  const [subIdInput , setSubIdInput] = useState()



  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSuggestions([]); // closes dropdown
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Set default text if provided
  useEffect(() => {
    const defaultText = props?.item?.text?.trim?.();
    if (defaultText) {
      setInputVal(defaultText);
      props?.setErrors((prevErrors) => ({
        ...prevErrors,
        [props?.index]: {
          key1: defaultText,
          displayName: defaultText,
        },
      }));
      localStorage.setItem("inputValue", JSON.stringify({ key1: defaultText }));
    }
  }, [props?.item?.text]);

  const handleChange = (e) => {
    let value = e?.target?.value?.trimStart();
    setInputVal(value);
    setSubIdInput(value)

    if (value.startsWith(" ")) return;
    if (!value) {
      props?.setErrors((prevErrors) => ({
        ...prevErrors,
        [props?.index]: { inputError: "Input cannot be empty" },
      }));
      return;
    }

    if (value.length >= 157) {
      setIsLimitlError("Maximum character value is 156");
      return;
    }

    if (props.flow === "email") {
      if (
        !/^[a-zA-Z0-9\s@.,]*$/.test(value) ||
        value.startsWith(".") ||
        value.startsWith(",")
      ) {
        setIsSpecialError("No Special characters are allowed");
        setIsLimitlError("");
      } else {
        setIsSpecialError("");
        setIsLimitlError("");
        localStorage.setItem("inputValue", JSON.stringify({ key1: value }));
      }
    } else if (
      !/^[0-9\s.,]*$/.test(value) ||
      value.startsWith(".") ||
      value.startsWith(",")
    ) {
      setIsSpecialError("No Special characters are allowed");
      setIsLimitlError("");
      props?.setErrors((prevErrors) => ({
        ...prevErrors,
        [props?.index]: { inputError: "Special characters" },
      }));
    } else {
      setIsSpecialError("");
      setIsLimitlError("");
      props?.setErrors((prevErrors) => ({
        ...prevErrors,
        [props?.index]: {
          key1: value,
          displayName: value,
        },
      }));
      localStorage.setItem("inputValue", JSON.stringify({ key1: value }));
    }

    // Debounced API call for 10-character input
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    if (props?.item?.data === "Merge" &&
      value.length === 10 &&
      !value.startsWith("1") &&
      !value.startsWith("3")) {

      debounceTimeout.current = setTimeout(async () => {
        setLoading(true);
        try {
          let serverResponse = await apiService.inputSearch(value);
    
          const { code, message, key1 } = serverResponse?.data || {};
    
          if (code === 200 && message === "SUCCESS" && key1) {
            const parsedData = JSON.parse(key1)?.data || [];
    
            // Enable dropdown only for multiple SubIDs
            if (parsedData.length > 1) {
              setSuggestions(parsedData);
            } else if (parsedData.length === 1) {
              // Auto-select if only one subID
              const singleItem = parsedData[0];
              setSuggestions([]);
              setInputVal(singleItem.value);
             

              props?.setErrors((prevErrors) => ({
                ...prevErrors,
                [props?.index]: {
                  key1: singleItem.value,
                  displayName: `${singleItem.value},${value}`,
                  selected: true,
                },
              }));
            
            } else {
              setSuggestions([]);
            }
          } else {
            setSuggestions([]); // No dropdown for other responses
          }
        } catch (error) {
          console.error("Error fetching suggestions:", error);
        } finally {
          setLoading(false);
        }
      }, 500);
    } else {
      setSuggestions([]);
    }
    
  };

  return (
    <>
      <div className="form-group" style={{ position: "relative" }}>
        <label className="sel" style={{ fontSize: "16px", color: "#444444" }}>
          <span className="asterisk-icon"></span>
        </label>
        <input
          type="text"
          className={`form-control error-${props?.index}`}
          placeholder="Enter the input here"
          // disabled={props?.item?.text || props.disable}
          value={inputVal}             // Controlled input
          onChange={handleChange}      // Use onChange
          ref={props.inputValue}
          style={{ marginLeft: "6px" }}
        />
        <span className="validate">&nbsp;</span>
        <div
          style={{
            color: "red",
            marginBottom: "12px",
            fontSize: 12,
            marginLeft: "10px",
          }}
        >
          {isSpecialError && isSpecialError}
          {isLimitError && isLimitError}
        </div>

        {/* Show suggestions dropdown */}
        {loading && <div className="suggestions">Loading...</div>}
        {!loading && suggestions.length > 0 && (
        <ul
        ref={dropdownRef}
        className="suggestions"
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
          border: "1px solid #dcdcdc",
          position: "absolute",
          backgroundColor: "#fff",
          width: "100%",
          zIndex: 1000,
          top: "100%",
          left: 0,
          maxHeight: "180px",
          overflowY: "auto",
          borderRadius: "6px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
          transition: "all 0.2s ease-in-out",
        }}
      >
        {suggestions.map((item, idx) => (
          <li
            key={idx}
            style={{
              padding: "10px 12px",
              cursor: "pointer",
              borderBottom: idx !== suggestions.length - 1 ? "1px solid #f1f1f1" : "none",
              fontSize: "14px",
              color: "#333",
              transition: "background 0.2s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f5f7fa")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
            onClick={() => {
              setInputVal(item.value);
            
              // Build latest errors object manually
              const updatedErrors = {
                ...props?.errors, // old errors
                [props?.index]: {
                  key1: `${item.value},${subIdInput}`,
                  displayName: `${item.value},${subIdInput}`,
                  selected: true,
                },
              };
            
              // Update state with new object
              props?.setErrors(updatedErrors);
            
              // Now you can safely use updatedErrors immediately
              const validValues = Object.values(updatedErrors).filter(Boolean);
              const input = validValues.length === 1
              ? validValues[0].key1
              : JSON.stringify(validValues.map(item => item.key1));
              const displayText = validValues.map(item => item.displayName).join(", ");
            
              props?.addMessages(input, props?.item?.code, props?.item?.text, displayText);
            
              // Store locally
              localStorage.setItem("inputValue", JSON.stringify({ key1: item.value }));
              setSuggestions([]);
            }}
            dangerouslySetInnerHTML={{ __html: item.name }}
          >

          </li>
        ))}
      </ul>
      
        )}
      </div>
    </>
  );
};

export default InputField;
